/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { CreateFileSystemModule } from '../../../file-system/create-file-system/create-file-system.module';
import { FsSmartGuiInfoModule } from '../../../file-system/fs-smartgui-info/fs-smartgui-info.module';
import { FrontTableClientNfsShareModule } from '../client-nfs-share/front-table-client-nfs-share/front-table-client-nfs-share.module';
import { CreateNfsShareComponent } from './create-nfs-share.component';

@NgModule({
    declarations: [CreateNfsShareComponent],
    exports: [CreateNfsShareComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FrontTableClientNfsShareModule,
        CreateFileSystemModule,
        FsSmartGuiInfoModule,
        FormsModule,
    ],
})
export class CreateNfsShareModule { }
